import { Component, Input, OnInit } from '@angular/core';
import { BreakTask } from '../../services/tasks-provider/tasks-provider.service';

@Component({
  selector: 'app-break-task-list-item',
  templateUrl: './break-task-list-item.component.html',
  styleUrls: ['./break-task-list-item.component.scss']
})
export class BreakTaskListItemComponent implements OnInit {
  @Input()
  task: BreakTask;

  constructor() {}

  ngOnInit() {}
}
